import React, { Component } from "react";
import PropTypes from "prop-types";
import icon from "../images/icone-doc-nao-assinado.svg";

export class Refused extends Component {
  handleClick() {
    this.props.onBack();
  }

  render() {
    return (
      <div className="container h-100">
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h1 className="card-title fw-bold text-white mt-3">NÃO É POSSÍVEL CONTINUAR PARA ASSINAR O DOCUMENTO</h1>
            <h5 className="card-text text-light mt-5">Você precisa voltar e concordar com nossos termos de uso e privacidade.</h5>
            <div className="row mt-5 justify-content-center">
              <div className="col-12 d-grid">
                <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClick()}>
                  VOLTAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Refused.propTypes = {
  back: PropTypes.func.isRequired,
};

export default Refused;
